import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function localToday(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function localDaysAgo(days) {
  return localToday(new Date(Date.now() - days * 86400000));
}

/**
 * Parse a scheduled_date value from the API (BSON datetime ISO string or YYYY-MM-DD)
 * and return a local Date at noon to avoid UTC-midnight timezone display issues.
 * e.g. "2026-04-08T00:00:00Z" in UTC-5 would otherwise show "April 7".
 */
export function parseScheduledDate(value) {
  if (!value) return null;
  const dateOnly = String(value).slice(0, 10); // "YYYY-MM-DD"
  return new Date(dateOnly + 'T12:00:00');     // local noon, safe for all timezones
}
